import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

export type AccessStatus = 'ativo' | 'pendente';

@Component({
  selector: 'app-box-status-access',
  templateUrl: './box-status-access.component.html',
  styleUrls: ['./box-status-access.component.scss'],
})
export class BoxStatusAccessComponent {
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() description: string = '';
  @Input() status: AccessStatus = 'pendente';
  @Input() hideAction: boolean = false;
  @Input() actionEnabled: boolean = false;
  @Input() loading: boolean = false;

  @Output() clickButtonAction = new EventEmitter<void>();

  get isAtivo(): boolean {
    return this.status === 'ativo';
  }
}
